export const ADDING_START = 'ADDING_START';
export const ADDING_SUCCESS = 'ADDING_SUCCESS';
export const ADDING_FAILED = 'ADDING_FAILED';

export const START_FETCHING_CONTACTS = 'START_FETCHING_CONTACTS';
export const FETCHED_CONTACTS_SUCCESS = 'FETCHED_CONTACTS_SUCCESS';
export const FETCHED_CONTACTS_FAILED = 'FETCHED_CONTACTS_FAILED';

export const START_EDITING_CONTACTS = 'START_EDITING_CONTACTS';
export const EDITING_SUCCESS = 'EDITING_SUCCESS';
export const EDITING_FAILED = 'EDITING_FAILED';

export const DELETE_CONTACT = 'DELETE_CONTACT';

export const SIGNUP_START = 'SIGNUP_START';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILED = 'SIGNUP_FAILED';

export const SIGNIN_START = 'SIGNIN_START';
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const SIGNIN_FAILED = 'SIGNIN_FAILED';

export const LOGOUT = 'LOGOUT';